import React, { Component } from "react"
import { ModalContainer, ModalDialog } from "react-modal-dialog"
import ComissaoItemForm from "./ComissaoItemForm"
import { HttpError } from "../../components"
import * as ApiHelper from "../../ApiHelper"
export default class ComissaoItemModal extends Component {
  constructor() {
    super()
    this.callBackItemModal = this.callBackItemModal.bind(this)
    this.state = { isShowingModal: false }
  }
  getUnidades() {
    ApiHelper.getComissaoItemEdit(this.props.itemID, (item, error) => {
      if (item) {
        this.props.callBack(item)
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  callBackItemModal() {
    this.getUnidades()
  }
  render() {
    if (this.state.httpError) {
      return (
        <div onClick={this.props.onClose}>
          {this.props.show && (
            <ModalContainer onClose={this.props.onClose}>
              <ModalDialog
                style={{ width: "70%" }}
                onClose={this.props.onClose}
              >
                <HttpError
                  message={this.state.httpError.message}
                  status={this.state.httpError.status}
                />
              </ModalDialog>
            </ModalContainer>
          )}
        </div>
      )
    }
    return (
      <div onClick={this.props.onClose}>
        {this.props.show && (
          <ModalContainer onClose={this.props.onClose}>
            <ModalDialog style={{ width: "70%" }} onClose={this.props.onClose}>
              <ComissaoItemForm
                itemID={this.props.itemID}
                callBackItem={this.callBackItemModal}
              />
            </ModalDialog>
          </ModalContainer>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/modais/ComissaoItemModal.js